export default "__VITE_ASSET__BeENq901__"